const lang = {
  en: {
    search: "Search",
    gptSearchPlaceholder: "Ask AI for your movie suggestions...",
    playBtn: "Play",
    starring: "Starring",
    director: "Director",
    reccView: "Recommended Viewing",
    mayLike: "You may like",
    cast: "Cast",
    about: "About",
    info: "Info",
    release: "Released",
    runtime: "Runtime",
    ogLang: "Original Language",
    ogRegion: "Region of Origin",
    hour: "hr",
    minute: "min",
  },

  kn: {
    search: "ಹುಡುಕಿ",
    gptSearchPlaceholder: "ನೀವು ಇಂದು ಏನನ್ನು ವೀಕ್ಷಿಸಲು ಬಯಸುತ್ತೀರಿ?",
    playBtn: "ಪ್ಲೇ ಮಾಡಿ",
    starring: "ನಟರು",
    director: "ನಿರ್ದೇಶಕ",
    reccView: "ಸೂಚಿತ ದೃಶ್ಯಗಳು",
    mayLike: "ನಿಮಗೆ ಇಷ್ಟವಾಗಬಹುದು",
    cast: "ಕಾಸ್ಟ್",
    about: "ಕುರಿತು",
    info: "ಮಾಹಿತಿ",
    release: "ಬಿಡುಗಡೆ ದಿನಾಂಕ",
    runtime: "ಚಾಲನಾ ಕಾಲ",
    ogLang: "ಮೂಲ ಭಾಷೆ",
    ogRegion: "ದೇಶ",
    hour: "ಗಂಟೆ",
    minute: "ನಿಮಿಷ",
    language: "Kannada",
    textTranslateQuery:"you are a translator who translates JSON data from english to Kannada, you only translate the values for example. {name:'Poor Things'} wiil be {name:'ಪೂರ್ ಥಿಂಗ್ಸ್'}. JSON Data: ",
    moreTranslateQuery:"you are a translator who translates JSON data from english to Kannada, you only translate the values for example. {name:'Aquaman and the Lost Kingdom'} will be {name:'ಅಕ್ವಾಮ್ಯಾನ್ ಅಂದ್ ದಿ ಲಾಸ್ಟ್ ಕಿಂಗ್‌ಡಮ್'}. JSON Data: ",
  },
  hi: {
    search: "खोजें",
    gptSearchPlaceholder: "आज आप क्या देखना चाहते हैं?",
    playBtn: "प्ले करें",
    starring: "अभिनेता ",
    director: "निर्देशक",
    reccView: "सुझाए गए देखने के लिए",
    mayLike: "आपको पसंद आ सकता है",
    cast: "कास्ट",
    about: "के बारे में",
    info: "जानकारी",
    release: "रिलीज़ की तारीख",
    runtime: "चलनकाल ",
    ogLang: "मूल भाषा",
    ogRegion: "देश",
    hour: "घंटे",
    minute: "मिनट",
    language: "Hindi",
    textTranslateQuery:"you are a translator who translates JSON data from english to hindi, you only translate the values for example. {name:'Poor Things'} wiil be {name:'पूर थिंग्स'}. JSON Data: ",
    moreTranslateQuery:"you are a translator who translates JSON data from english to Hindi, you only translate the values for example. {name:'Aquaman and the Lost Kingdom'} wiil be {name:'एक्वामैन एंड द लॉस्ट किंगडम'}. JSON Data: "
  },









  genreTranslation: {
    28: {
      en: "Action",
      kn: "ಆಕ್ಷನ್",
      hi: "एक्शन",
    },
    12: {
      en: "Adventure",
      kn: "ಸಾಹಸ",
      hi: "साहसिक",
    },
    16: {
      en: "Animation",
      kn: "ಅನಿಮೇಷನ್",
      hi: "एनिमेशन",
    },
    35: {
      en: "Comedy",
      kn: "ಹಾಸ್ಯ",
      hi: "हास्य",
    },
    80: {
      en: "Crime",
      kn: "ಅಪರಾಧ",
      hi: "अपराध",
    },
    99: {
      en: "Documentary",
      kn: "ಸಾಕ್ಷ್ಯಚಿತ್ರ",
      hi: "डॉक्यूमेंट्री",
    },
    18: {
      en: "Drama",
      kn: "ಡ್ರಾಮಾ",
      hi: "ड्रामा",
    },
    10751: {
      en: "Family",
      kn: "ಕೌಟುಂಬಿಕ",
      hi: "पारिवारिक",
    },
    14: {
      en: "Fantasy",
      kn: "ಫ್ಯಾಂಟಸಿ",
      hi: "फंतासी",
    },
    36: {
      en: "History",
      kn: "ಐತಿಹಾಸಿಕ",
      hi: "ऐतिहासिक",
    },
    27: {
      en: "Horror",
      kn: "ಭಯಾನಕ",
      hi: "डरावनी",
    },
    10402: {
      en: "Music",
      kn: "ಸಂಗೀತ",
      hi: "संगीत",
    },
    9648: {
      en: "Mystery",
      kn: "ರಹಸ್ಯ",
      hi: "रहस्य",
    },
    10749: {
      en: "Romance",
      kn: "ರೋಮ್ಯಾನ್ಸ್",
      hi: "रोमांस",
    },
    878: {
      en: "Science Fiction",
      kn: "ಸೈನ್ಸ್ ಫಿಕ್ಷನ್",
      hi: "साइंस फ़िक्शन",
    },
    10770: {
      en: "TV Movie",
      kn: "ಟಿವಿ ಚಲನಚಿತ್ರ",
      hi: "टीवी मूवी",
    },
    53: {
      en: "Thriller",
      kn: "ಥ್ರಿಲ್ಲರ್",
      hi: "थ्रिलर",
    },
    10752: {
      en: "War",
      kn: "ಯುದ್ಧ",
      hi: "युद्ध",
    },
    37: {
      en: "Western",
      kn: "ಪಾಶ್ಚಾತ್ಯ",
      hi: "वेस्टर्न",
    },
  },
};

export default lang;
